import { Platform } from "@/types";

export const PLATFORM_META: Record<Platform, { label: string; color: string; logo: string }>
= {
  instagram: {
    label: "Instagram",
    color: "#E1306C",
    logo: "/logos/instagram-white-icon.png",
  },
  tiktok: {
    label: "TikTok",
    color: "#010101",
    logo: "/logos/tiktok-xxl.png",
  },
  youtube: {
    label: "YouTube",
    color: "#FF0000",
    logo: "/logos/youtube-shorts-white-icon.png",
  },
  snapchat: {
    label: "Snapchat",
    color: "#FFFC00",
    logo: "/logos/snapchat-2-xxl.png",
  },
};

export const PLATFORM_OPTIONS = Object.entries(PLATFORM_META).map(
  ([value, meta]) => ({
    value: value as Platform,
    label: meta.label,
    color: meta.color,
    logo: meta.logo,
  })
);
